import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 10h6","key":"svg-1"}],["path",{"d":"M9 14h6","key":"svg-2"}]]

const IconCreativeCommonsNd = createReactComponent('outline', 'creative-commons-nd', 'CreativeCommonsNd', __iconNode);

export default IconCreativeCommonsNd;